export default __webpack_public_path__ + "static/Asset6@2x-150f00c3df2ad6f72d0968e1a505663a.png";